import type { GetGoogleImageResponse, GetGooglePlaceDetailResponse, GetGooglePlaceRatingResponse, TripGooglePlaceDetail } from '../places/types'
import { baseUri, getOptions } from '../utils'

import request from 'api/requestUtils'

// This function is used to fetch a single image for a place when we already know the name of the resource
export async function getGooglePlacePhoto(
  name: string,
  accessToken?: string,
): Promise<GetGoogleImageResponse['result']> {
  const uri = `${baseUri}/places/photos`
  const params = new URLSearchParams([])
  params.append('name', name)
  const encodedUri = uri + '?' + params.toString()
  return request
    .get<GetGoogleImageResponse>(encodedUri, {
      ...getOptions(accessToken),
    })
    .then((response) => response.result)
}

export async function getGooglePlaceRating(placeId: string) {
  const uri = `${baseUri}/places/${placeId}/rating`
  return request
    .get<GetGooglePlaceRatingResponse>(uri, {
      ...getOptions(),
    })
    .then((response) => response.result)
}

export interface GooglePlaceDetailRequest<
  Field extends keyof TripGooglePlaceDetail,
> {
  placeId: string
  fields?: Array<Field>
}
export async function getGooglePlaceDetail({
  placeId,
  fields,
}: GooglePlaceDetailRequest<
  keyof TripGooglePlaceDetail
>): Promise<TripGooglePlaceDetail> {
  const uri = `${baseUri}/places/${placeId}/detail`
  const params = new URLSearchParams([])
  if (fields) {
    fields.forEach((field) => {
      params.append('fields[]', field)
    })
  }
  const encodedUri = uri + '?' + params.toString()
  return request
    .get<GetGooglePlaceDetailResponse>(encodedUri, {
      ...getOptions(),
    })
    .then((response) => response.result)
}
